import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-number-input';
import '../index.css';

import { AppText, Button, IconBox } from '@zippeditoolsjs/ui-web';
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';
import BackLink from '../../ui/controls/BackLink';

// The reCAPTCHA verifier anchors on #send-info-button, so that id must stay:
// submitting the phone number is what trips the invisible challenge.
export default function PhoneNumberForm(props) {
  const PhoneNumber = props.PhoneNumber ? props.PhoneNumber : '';
  const locked = Boolean(props.sendingSMS) || Boolean(props.busy);

  const handleChangePhone = newPhone => {
    props.phoneRef.current = newPhone;
    props.setPhoneNumber(newPhone);
  };

  const { t } = useTranslation();

  useEffect(() => {
    async function asyncSetUpRecaptha() {
      await props.setUpRecaptha();
    }
    asyncSetUpRecaptha();
  }, []);

  return (
    <div className="flex flex-col">
      {props.onBack ? (
        <BackLink onClick={props.onBack} disabled={locked} />
      ) : null}

      <IconBox className="mb-4">
        <IconComponent iconName="chatbubble-ellipses" style={{ fontSize: 22 }} />
      </IconBox>

      <AppText variant="titleXLarge" as="h3" className="mb-2">
        {t('heimdal_app.Login.phone_enroll_title')}
      </AppText>
      <AppText variant="bodyMedium" as="p" className="mb-6 text-secondary">
        {t('heimdal_app.Login.phone_enroll_subtitle')}
      </AppText>

      <div className="mb-[18px] mt-1.5">
        <PhoneInput
          international
          countryCallingCodeEditable={false}
          defaultCountry="CL"
          displayInitialValueAsLocalNumber={true}
          value={PhoneNumber}
          onChange={handleChangePhone}
        />
      </div>

      <Button
        id="send-info-button"
        type="submit"
        fullWidth
        loading={props.sendingSMS}
        disabled={!isPossiblePhoneNumber(PhoneNumber) || locked}
        onClick={props.onSendSMS}>
        {t('heimdal_app.Login.submit')}
      </Button>

      {props.onLater ? (
        <button
          type="button"
          onClick={props.onLater}
          disabled={locked}
          className="mt-3.5 flex cursor-pointer items-center justify-center gap-1.5 border-0 bg-transparent p-1 font-sans text-[10.5px] font-semibold uppercase tracking-[0.1em] text-muted transition-colors hover:text-accent disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:text-muted">
          {t('heimdal_app.TOTP.offer_later')}
        </button>
      ) : null}
    </div>
  );
}
